import { SegmentGroup } from '@chakra-ui/react';
import * as React from 'react';

interface Item {
  value: string;
  label: React.ReactNode;
  disabled?: boolean;
}

export interface SegmentedControlProps extends SegmentGroup.RootProps {
  items: Array<string | Item>;
}

function normalize(items: Array<string | Item>): Item[] {
  return items.map((item) => {
    if (typeof item === 'string') return { value: item, label: item };
    return item;
  });
}

const SegmentedControl = React.forwardRef<
  HTMLDivElement,
  SegmentedControlProps
>(function SegmentedControl(props, ref) {
  const { items, ...rest } = props;
  const data = React.useMemo(() => normalize(items), [items]);

  return (
    <SegmentGroup.Root ref={ref} {...rest}>
      <SegmentGroup.Indicator />
      {data.map((item) => (
        <SegmentGroup.Item
          key={item.value}
          background="white"
          border="1px solid"
          borderColor="green.800"
          borderRadius="none"
          focusRing="outside"
          focusRingColor="blue.500"
          focusRingOffset="0"
          color="green.800"
          cursor="pointer"
          disabled={item.disabled}
          fontWeight="medium"
          value={item.value}
          _focus={{
            zIndex: 1, // Float focused buttons so that the focus ring is fully visible
          }}
          _checked={{ background: 'green.800', color: 'white' }}
          _first={{ borderTopLeftRadius: 'lg', borderBottomLeftRadius: 'lg' }}
          _last={{ borderTopRightRadius: 'lg', borderBottomRightRadius: 'lg' }}
        >
          <SegmentGroup.ItemText>{item.label}</SegmentGroup.ItemText>
          <SegmentGroup.ItemHiddenInput />
        </SegmentGroup.Item>
      ))}
    </SegmentGroup.Root>
  );
});

export default SegmentedControl;
